module.exports = __webpack_public_path__ + "static/media/매인페이지.2e197ebd.png";